import React, {} from 'react';
export const SignInContext = React.createContext({});
/**
 * Makes the login site's facade available to every hook below it. The login site's `main.tsx` builds the facade with
 * `createTripOsUsersApp` and renders this provider once, above the router.
 */
export function SignInContextProvider({ facade, children }) {
    return React.createElement(SignInContext.Provider, { value: { facade } }, children);
}
//# sourceMappingURL=SignInContextProvider.js.map